<template> 
  <div id="nav" style="border: 0px solid black;">   
    <h3>Navi</h3>   
    <a href="CovBinderInPDB_2022Q4.zip">Download All Records and Binder Structures</a>   
    <a href="tables.html">Tables 4 & 5 & 6</a> 
    <a href="binder.html?g=drugbank">Covalent Binders also in DrugBank</a>  
    <a href="binder.html?g=fda">Covalent Binders also as FDA-approved Drug</a> 
    <a href="https://doi.org/10.1021/acs.jcim.2c01216">Publication of this Database</a> 
  </div> 
</template>  

<script>
  export default {
    name: 'leftSideBar',  
  }  
  // text-decoration: none;
</script> 
 
<style scoped>
  a {
    color:black;
    border: 0px solid black; 
    margin-bottom: 20px;
    text-align: center
  }
  #nav {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap-reverse; 
  }
</style>